import { cloneDeep } from 'lodash';

const defaultState = {
  data: [],
  loading: false,
  error: false,
};

const siteRoutes = function (state = defaultState, action) {
  let target, data;

  switch (action.type) {
    case 'CLEAR_SITEROUTES_CACHE':
      return { ...state, data: [] };

    case 'SET_SITE_ROUTES':
      return { ...state, data: action.data };

    case 'REMOVE_SITE_ROUTE':
      data = [...state.data];
      target = data.findIndex((d) => d.siteroute_id === action.data.siteroute_id);
      if (target > -1) {
        data.splice(target, 1);
      }
      return { ...state, data };

    case 'INSERT_SITE_ROUTE':
      return { ...state, data: [...state.data, ...action.data] };

    case 'SET_SITE_ROUTES_LOADING':
      return {
        ...state,
        loading: action.data,
      };

    case 'SET_SITE_ROUTES_ERROR':
      return {
        ...state,
        error: action.data,
      };

    case 'UPDATE_SITE_ROUTE':
      data = [...state.data];
      target = data.findIndex(
        (d) => d.siteroute_id === action.data.id || d.siteroute_id === action.data.siteroute_id
      );
      console.log(target);
      if (target > -1) {
        data[target] = action.data;
      }
      return { ...state, data };

    case 'INSERT_ROUTE_SEAT':
      data = [...state.data];
      target = data.findIndex((d) => d.siteroute_id === +action.data.siteroute_id);
      if (target > -1) {
        let result = { ...data[target] };
        result['routeseats'].push(action.data);
        data[target] = result;
      }
      return { ...state, data };

    //in removal calls, action.data is id to be removed
    case 'DELETE_ROUTE_SEAT':
      data = [...state.data];
      target = data.findIndex((d) => d.siteroute_id === +action.data.siteroute_id);
      if (target > -1) {
        let result = { ...data[target] };
        let filtered = result['routeseats'].filter(
          (item) => item.routeseat_id !== +action.data.routeseat_id
        );
        result['routeseats'] = filtered;
        data[target] = result;
      }
      return { ...state, data };

    case 'REORDER_ROUTE_SEATS':
      data = cloneDeep(state.data);
      target = data.findIndex((d) => d.siteroute_id === +action.data.siteroute_id);
      if (target > -1) {
        let result = cloneDeep(data[target]);
        let sortedSeats = action.data.routeseats.sort(
          (a, b) => a.seat_order_position - b.seat_order_position
        );
        let newSeats = [];
        sortedSeats.forEach((item) => {
          let seat = result.routeseats.find((seat) => seat.routeseat_id === item.seat_id);

          if (seat) {
            seat.seat_order_position = item.seat_order_position;
            newSeats.push(seat);
          }
        });

        result['routeseats'] = newSeats;
        data[target] = result;
      }
      return { ...state, data };

    case 'UPDATE_ROUTE_SEAT_SITE_ORDER':
      data = cloneDeep(state.data);
      target = data.findIndex((d) => d.siteroute_id === +action.data.siteroute_id);

      if (target > -1) {
        let result = { ...data[target] };
        let routeseatTarget = result['routeseats'].findIndex(
          (d) => d.routeseat_id === +action.data.routeseat_id
        );
        // yes unfortunately for now the data IS nested as sites.sites
        let sortedSites =
          action.data.sites.sites &&
          action.data.sites.sites.sort((a, b) => a.site_order_position - b.site_order_position);
        let newSites = [];

        sortedSites &&
          sortedSites.forEach((item) => {
            let sites = result['routeseats'][routeseatTarget].sites;
            let site = sites && sites.find((site) => site.site_id === item.site_id);

            if (site) {
              site.site_order_position = item.site_order_position;
              newSites.push(site);
            }
          });

        if (newSites.length > 0) {
          result['routeseats'][routeseatTarget].sites = newSites;
        }

        data[target] = result;
      }

      return { ...state, data };

    case 'INSERT_ROUTE_SEAT_SITE':
      data = cloneDeep(state.data);
      target = data.findIndex((d) => d.siteroute_id === +action.data.siteroute_id);
      if (target > -1) {
        let result = { ...data[target] };
        let routeseatTarget = result['routeseats'].findIndex(
          (d) => d.routeseat_id === +action.data.routeseat_id
        );
        if (result['routeseats'][routeseatTarget].sites) {
          result['routeseats'][routeseatTarget].sites.push(action.data);
        } else {
          result['routeseats'][routeseatTarget].sites = [action.data];
        }

        data[target] = result;
      }
      return { ...state, data };

    case 'UPDATE_ROUTE_SEAT_SITE':
      data = cloneDeep(state.data);
      target = data.findIndex((d) => d.siteroute_id === +action.data.siteroute_id);
      if (target > -1) {
        let result = { ...data[target] };
        let routeseatTarget = result['routeseats'].findIndex(
          (d) => d.routeseat_id === +action.data.routeseat_id
        );
        let siteTarget = result['routeseats'][routeseatTarget].findIndex(
          (d) => d.site_id === +action.data.site_id
        );
        result['routeseats'][routeseatTarget][siteTarget] = action.data;
        data[target] = result;
      }
      return { ...state, data };

    //in removal calls, action.data is id to be removed
    case 'REMOVE_ROUTE_SEAT_SITE':
      data = cloneDeep(state.data);
      data.forEach((d) => {
        d.routeseats.forEach((rs) => {
          let site_index = rs.sites.findIndex(
            (s) => s.routeseatsite_id === action.data.routeseatsite_id
          );
          if (site_index > -1) {
            rs.sites = rs.sites.filter(
              (item) => item.routeseatsite_id !== +action.data.routeseatsite_id
            );
          }
        });
      });
      return { ...state, data };

    default:
      return state;
  }
};

export default siteRoutes;
